<template>
  <div class="consulta-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Consultas y Reclamos</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Centro de Atención y Reclamos</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-frequently-asked-questions</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <v-tabs v-model="tab" background-color="transparent" color="primary" grow class="premium-tabs">
            <v-tab class="font-weight-bold">
              <v-icon :left="!$vuetify.breakpoint.xs">mdi-plus-circle-outline</v-icon>
              <span class="d-none d-sm-inline">Nueva Consulta</span>
            </v-tab>
            <v-tab class="font-weight-bold">
              <v-icon :left="!$vuetify.breakpoint.xs">mdi-chat-question-outline</v-icon>
              <span class="d-none d-sm-inline">Generales</span>
            </v-tab>
            <v-tab class="font-weight-bold">
              <v-icon :left="!$vuetify.breakpoint.xs">mdi-currency-usd</v-icon>
              <span class="d-none d-sm-inline">Pagos</span>
            </v-tab>
          </v-tabs>

          <v-divider></v-divider>

          <div class="pa-6 content-area bg-light">
            <!-- TAB 0: NUEVA CONSULTA -->
            <div v-show="tab === 0">
              <v-row>
                <v-col cols="12">
                  <div class="text-subtitle-2 font-weight-bold mb-2">Asunto</div>
                  <v-text-field
                    v-model="titulo"
                    placeholder="Describa en pocas palabras su consulta"
                    outlined
                    rounded
                    dense
                    prepend-inner-icon="mdi-format-title"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <div class="text-subtitle-2 font-weight-bold mb-2">Descripción Detallada</div>
                  <v-textarea
                    v-model="descripcion"
                    placeholder="Describa en detalle la consulta..."
                    outlined
                    rounded
                    auto-grow
                    rows="4"
                    prepend-inner-icon="mdi-text"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <div class="text-subtitle-2 font-weight-bold mb-2">Archivos Adjuntos</div>
                  <v-file-input
                    show-size
                    v-model="files"
                    multiple
                    counter
                    accept="image/*"
                    placeholder="Seleccionar imágenes..."
                    outlined
                    rounded
                    dense
                    prepend-inner-icon="mdi-camera"
                    prepend-icon=""
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        small
                        label
                        close
                        @click:close="remove(index)"
                        color="primary"
                        class="ma-1"
                      >
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>

              <div class="d-flex justify-end mt-4">
                <v-btn
                  color="primary"
                  rounded
                  depressed
                  large
                  class="px-8 shadow-premium"
                  @click="addConsulta()"
                  :disabled="!titulo.trim() || !descripcion.trim()"
                >
                  <v-icon left>mdi-send-check</v-icon>
                  Crear Consulta
                </v-btn>
              </div>
            </div>

            <!-- TAB 1: CONSULTAS GENERALES -->
            <div v-show="tab === 1">
              <div v-if="!consultas || consultas.length === 0" class="text-center pa-10 bg-light-gradient rounded-xl mt-4">
                <v-icon size="64" color="grey lighten-2">mdi-message-question-outline</v-icon>
                <h3 class="text-h6 grey--text text--darken-1 mt-4">No tienes consultas generales</h3>
                <p class="text-body-2 grey--text">Tus solicitudes aparecerán aquí una vez creadas.</p>
              </div>
              
              <v-row v-else class="mt-2">
                <v-col cols="12" md="6" lg="4" v-for="(consultaData, consultaKey) in consultas" :key="consultaKey">
                  <v-card class="rounded-xl border-light hover-card h-100 d-flex flex-column" elevation="0">
                    <div class="pa-4 flex-grow-1">
                      <div class="d-flex justify-space-between align-start mb-2">
                        <v-chip
                          small
                          :color="consultaData.ConsultaGeneralesRespuesta ? 'success lighten-5' : 'warning lighten-5'"
                          :text-color="consultaData.ConsultaGeneralesRespuesta ? 'success darken-1' : 'warning darken-2'"
                          class="font-weight-bold"
                        >
                          {{ consultaData.ConsultaGeneralesRespuesta ? 'Respondida' : 'Pendiente' }}
                        </v-chip>
                        <span class="text-caption grey--text"><v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>{{ consultaData.tiempo }}</span>
                      </div>
                      
                      <h3 class="text-subtitle-1 font-weight-bold primary-text line-height-1 mt-3 mb-2 text-truncate" :title="consultaData.titulo">
                        {{ consultaData.titulo }}
                      </h3>
                      
                      <div class="text-caption grey--text text--darken-2 mt-2" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                        {{ consultaData.descripcion }}
                      </div>
                    </div>

                    <!-- Actions Footer -->
                    <div class="px-4 py-3 bg-light border-top mt-auto">
                      <div v-if="consultaData.ConsultaGeneralesRespuesta">
                        <v-btn small block color="success" outlined rounded @click="openDialog('desc', consultaKey)">
                          <v-icon left small>mdi-comment-eye-outline</v-icon> Ver Respuesta
                        </v-btn>
                        <div class="mt-2 d-flex justify-center align-center">
                          <star-rating v-model="consultaData.puntaje" @rating-selected="calificar($event,consultaData.id,'G')" :increment="0.5" :max-rating="5" inactive-color="#f1f1f1" active-color="#FFD700" :star-size="20" :read-only="consultaData.tiene_puntuacion=='S'" :show-rating="false"></star-rating>
                        </div>
                      </div>
                      <div v-else class="text-center text-caption grey--text py-1">
                        <v-icon small color="grey lighten-1">mdi-dots-horizontal</v-icon> Aún no respondida
                      </div>
                    </div>
                  </v-card>

                  <!-- Dialog for Respuesta General -->
                  <v-dialog v-model="dialog_desc[consultaKey]" max-width="500">
                    <v-card class="rounded-xl">
                      <v-card-title class="primary white--text text-subtitle-1 font-weight-bold px-4 py-3">
                        <v-icon color="white" class="mr-2">mdi-forum</v-icon>
                        Respuesta
                      </v-card-title>
                      <v-card-text class="pa-5 text-body-1 grey--text text--darken-3">
                        <div class="mb-4">
                          <strong>Consulta:</strong><br/>
                          {{ consultaData.descripcion }}
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <div>
                          <strong>Respuesta ({{ consultaData.usu_nombre || 'Soporte' }}):</strong><br/>
                          {{ consultaData.ConsultaGeneralesRespuesta ? consultaData.ConsultaGeneralesRespuesta.respuesta : '' }}
                        </div>
                      </v-card-text>
                      <v-card-actions class="pa-4 pt-0 border-top">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text rounded @click="$set(dialog_desc, consultaKey, false)" class="px-4">Cerrar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-col>
              </v-row>
            </div>

            <!-- TAB 2: INFORMES DE PAGO -->
            <div v-show="tab === 2">
              <div v-if="!consultasAcreditacion || consultasAcreditacion.length === 0" class="text-center pa-10 bg-light-gradient rounded-xl mt-4">
                <v-icon size="64" color="grey lighten-2">mdi-currency-usd-off</v-icon>
                <h3 class="text-h6 grey--text text--darken-1 mt-4">No tienes informes de pagos</h3>
              </div>
              
              <v-row v-else class="mt-2">
                <v-col cols="12" md="6" lg="4" v-for="(consultaDat, consultaKey) in consultasAcreditacion" :key="consultaKey">
                  <v-card class="rounded-xl border-light hover-card h-100 d-flex flex-column" elevation="0">
                    <div class="pa-4 flex-grow-1">
                      <div class="d-flex justify-space-between align-start mb-2">
                        <v-chip
                          small
                          :color="consultaDat.ConsultaAcreditacionRespuesta ? 'success lighten-5' : 'warning lighten-5'"
                          :text-color="consultaDat.ConsultaAcreditacionRespuesta ? 'success darken-1' : 'warning darken-2'"
                          class="font-weight-bold"
                        >
                          {{ consultaDat.ConsultaAcreditacionRespuesta ? 'Respondida' : 'Pendiente' }}
                        </v-chip>
                        <span class="text-caption grey--text"><v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>{{ consultaDat.tiempo }}</span>
                      </div>
                      
                      <h3 class="text-subtitle-1 font-weight-bold primary-text line-height-1 mt-3 mb-2 text-truncate" :title="consultaDat.titulo">
                        {{ consultaDat.titulo }}
                      </h3>
                    </div>

                    <!-- Actions Footer -->
                    <div class="px-4 py-3 bg-light border-top mt-auto">
                      <div v-if="consultaDat.ConsultaAcreditacionRespuesta">
                        <v-btn small block color="success" outlined rounded @click="openDialogAcred(consultaDat, consultaKey)">
                          <v-icon left small>mdi-comment-eye-outline</v-icon> Ver Respuesta
                        </v-btn>
                        <div class="mt-2 d-flex justify-center align-center">
                          <star-rating v-model="consultaDat.puntaje" @rating-selected="calificar($event,consultaDat.id,'A')" :increment="0.5" :max-rating="5" inactive-color="#f1f1f1" active-color="#FFD700" :star-size="20" :read-only="consultaDat.tiene_puntuacion=='S'" :show-rating="false"></star-rating>
                        </div>
                      </div>
                      <div v-else class="text-center text-caption grey--text py-1">
                        <v-icon small color="grey lighten-1">mdi-dots-horizontal</v-icon> Aún no respondida
                      </div>
                    </div>
                  </v-card>

                  <!-- Dialog for Respuesta Acreditacion -->
                  <v-dialog v-model="dialog_acred[consultaKey]" max-width="500">
                    <v-card class="rounded-xl">
                      <v-card-title class="success white--text text-subtitle-1 font-weight-bold px-4 py-3">
                        <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
                        Respuesta de Pagos
                      </v-card-title>
                      <v-card-text class="pa-5 text-body-1 grey--text text--darken-3">
                        <div>
                          <strong>Respuesta ({{ consultaDat.usu_nombre || 'Soporte' }}):</strong><br/>
                          {{ respuestaAcreditacion }}
                        </div>
                      </v-card-text>
                      <v-card-actions class="pa-4 pt-0 border-top">
                        <v-spacer></v-spacer>
                        <v-btn color="success" text rounded @click="$set(dialog_acred, consultaKey, false)" class="px-4">Cerrar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Consulta",
  components: {
    CardIeaAppMain,
    StarRating
  },

  data: () => ({
    tab: 0,
    title:"Nueva consulta",
    dialog_desc: [],
    dialog: [],
    dialog_acred: [],
    titulo: '',
    descripcion: '',
    consultas:[],
    consultasAcreditacion:[],
    files:[],
    respuestaAcreditacion : '',
    rating:3
  }),

  methods: {
    openDialog(type, key) {
      this.$set(this.dialog_desc, key, true);
    },
    openDialogAcred(data, key) {
      this.printConsole(data);
      this.$set(this.dialog_acred, key, true);
    },
    async calificar(puntaje,idConsulta,tipo){
      let url = "consultas-generales/calificar";
      let params = new FormData();
      params.append('id_consulta',idConsulta);
      params.append('puntaje',puntaje);
      params.append('tipo',tipo);

      await this.$API
        .post({
          url: url,
          data: params
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    remove (index) {
      this.files.splice(index, 1)
    },

    printConsole(data){
      this.respuestaAcreditacion = data.ConsultaAcreditacionRespuesta.respuesta;
    },
    
    async addConsulta() {
      if(this.titulo.trim() == "" || this.descripcion.trim() == ""){
        alert('Escribe el titulo y descripción de tu consulta')
        return;
      }
      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('descripcion',this.descripcion);
      if (this.files && this.files.length) {
        formData.append('cantidadImagen',this.files.length);
        let i = 0;
        for (let file of this.files) {
            formData.append(`imagen_${i}`, file, file.name);
            i++;
        }
      } else {
        formData.append('cantidadImagen',0);
      }
      
      let url = "consultas-generales/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
          this.tab = 1;
        });  
    },
    async loadConsultas() {
      let url = "consultas-generales";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultas = res;
          for (let index = 0; index < this.consultas.length; index++) {
            this.dialog = [];
            this.dialog[index] = false;
            this.dialog_desc = [];
            this.dialog_desc[index] = false;
          }
        });
    },
    async loadConsultasAcreditacion() {
      let url = "consultas-acreditacion";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultasAcreditacion = res;
          for (let index = 0; index < this.consultasAcreditacion.length; index++) {
            this.dialog_acred = [];
            this.dialog_acred[index] = false;
          }
        });
    }
  },

  mounted() {
    this.loadConsultas();
    this.loadConsultasAcreditacion();
  },
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.consulta-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.premium-tabs .v-tab {
  text-transform: none !important;
  letter-spacing: normal !important;
  font-size: 1.05rem !important;
  color: #64748b !important;
  transition: all 0.3s ease;
}
.premium-tabs .v-tab--active {
  color: #1976d2 !important;
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-top { border-top: 1px solid rgba(0, 0, 0, 0.05); }

.hover-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15) !important;
}

.shadow-premium {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
}

.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
